module.exports = "/images/autoxkm@2x.png?b7f7e0eca16323e4178608b8214c7905";